// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/history/index.scss
// module id = 3012
// module chunks = 13